import React, { useMemo } from "react";
import { Alert } from "antd";
import { getCharChannelSizesWarnings } from "frontend-lib/SizeChecker";
import { ChannelWarningMessages } from "frontend-lib/SizeChecker/types";
import { useTranslation } from "react-i18next";
import styles from "./CharSizeWarning.module.scss";
const { charSizeWarning } = styles;
interface props {
    text: string;
    chatChannel: string;
}

const getChannelWarnings = (warnings: ChannelWarningMessages, chatChannel: string) => {
    const listWarnings = Object.entries(warnings);
    const channels = listWarnings
        .filter(([_, warning]) => warning.show)
        .filter((item) => item[0] === chatChannel.toLocaleLowerCase());
    return channels;
};

function CharSizeWarning({ text, chatChannel }: props) {
    const { t } = useTranslation();
    const channelsWithWarning = useMemo(() => {
        const warnings = getCharChannelSizesWarnings(text);
        const channels = getChannelWarnings(warnings, chatChannel);
        return channels;
    }, [text, chatChannel]);

    if (!channelsWithWarning.length) {
        return null;
    }

    return (
        <div className={charSizeWarning}>
            <Alert
                message={t("agentCharExceded", { channel: chatChannel.toLocaleLowerCase() })}
                type="warning"
                showIcon
                closable
            />
        </div>
    );
}

export default CharSizeWarning;
